/* import __COLOCATED_TEMPLATE__ from './connected-accounts.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type DiscordIntegrationModel from 'embercom/models/discord/integration';

interface Args {
  discordIntegrations: DiscordIntegrationModel[];
  authenticate: () => void;
  showRemoveModal: (integration: DiscordIntegrationModel) => void;
}

export default class ConnectedAccounts extends Component<Args> {
  @tracked fetchError: string | null = null;

  get firstDiscordIntegration(): DiscordIntegrationModel | null {
    return this.args.discordIntegrations[0] || null;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Discord::ConnectedAccounts': typeof ConnectedAccounts;
    'new-settings/channels/discord/connected-accounts': typeof ConnectedAccounts;
  }
}
